import React, { useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm, useDataRefresh} from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import PropTypes from 'prop-types';
import metadata from './RequiredSignaturesComponent.metadata.json5';
import messages from './RequiredSignaturesComponent.messages';
import styles from './RequiredSignaturesComponent.module.scss';

const RequiredSignaturesComponent = (props) => {
    const { 
        id,
        requiredSignaturesForms,
        isSignatureOnFileAvailable,
        appSignatureTypeList,
        signatureTypeList,
        shouldShowLanguageOption,
        clearActionFields,
        signatureTypeChange,
        checkIfEmailsAreDuplicated,
        shouldShowSecondEmail,
        shouldShowSecondMobile,
        updateSecondaryInsuredEmail,
        onValidate,
        handleOnBlur,
        submissionVM,
        showValidationErrors
    } = props;

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();
    const isEsignOptionSelected = _.get(submissionVM, 'esignature_ML.esignatureOptions.value');
    const isPNI = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value');
     const isEsignExt = _.get(submissionVM, 'esignature_ML.esign_Ext.value');

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const hasBothSecondaryEmailAndMobileEntered = (rsForm) => {
        const hasPhone = _.get(rsForm, 'secondaryMobileNumber.value') != null
            && _.get(rsForm, 'secondaryMobileNumber.value') !== '';
        const hasEmail = _.get(rsForm, 'secondEmail.value') != null
            && _.get(rsForm, 'secondEmail.value') !== '';

        return hasPhone && hasEmail;
    };

    const onFormValidationChange = (isValid) => {
        const hasBothEmailAndMobile = isEsignOptionSelected?.code === 'Text'
            && requiredSignaturesForms.some(hasBothSecondaryEmailAndMobileEntered);

        setComponentValidation(isValid && !hasBothEmailAndMobile);
    };

console.log("props")
    const getSecondEmailLabel = (form) => {
        if (form.secondaryInsuredEmailRequired.value) {
            return translator(messages.secondaryNamedInsuredEmail);
        }
        if (form.excludedDriverEmailRequired.value) {
            return translator(messages.excludedDriverEmail);
        } 
        if (form.spouseEmailRequired.value) {
            return translator(messages.spouseEmail);
        }
        return translator(messages.secondEmail);
    };

    const getSecondMobileNumberLabel = (form) => {
        if (form?.secondaryMobileNumberRequired?.value) {
            return translator(messages.secondMobileNumber);
        }
        if (form?.excludedDriverMobileNumberRequired?.value) {
            return translator(messages.excludedMobileNumber);
        }
    }

    const onTrimPrimaryEmail = ( rsForm, event ) => {
        let email = rsForm.namedInsuredEmail.value;
        if(email !== "" && email !== undefined){
            email = email.trim();
            rsForm.namedInsuredEmail.value = email;
        }

        let email1 = event.target.value;
        if(email1 !== "" && email1 !== undefined){
            email1 = email1.trim();
            event.target.value = email1;
        }
    }

    const onTrimSecondaryEmail = ( rsForm, event ) => {
        let email = rsForm.secondEmail.value;
        if(email !== "" && email !== undefined){
            email = email.trim();
            rsForm.secondEmail.value = email;
        }

        let email1 = event.target.value;
        if(email1 !== "" && email1 !== undefined){
            email1 = email1.trim();
            event.target.value = email1;
        }
    }

    const generateRsFormsOverrides = () => {
        const formatTypelistAvailableValues = (typelist) => {
            if (!typelist) return [];
            return typelist.map((typekey) => ({
                code: typekey.code,
                name: translator({
                    id: typekey.name,
                    defaultMessage: typekey.name
                })
            }));
        };
           const policyState = _.get(submissionVM,'baseData.policyAddress_ML.state.code');
           const drivers = _.get(submissionVM,'lobData.personalAuto.coverables.drivers.value',[]);
           const hasSecondaryDriverAsSpouse = drivers.some((driver) =>driver.relationshipToInsured_ML === 'spouse' && driver.isPolicyHolder !== true);
           const shouldHideESignature =policyState === 'CO' && hasSecondaryDriverAsSpouse;
           const overrides = requiredSignaturesForms.map((rsForm, index) => {
               const availableSignatureTypes = isSignatureOnFileAvailable(
                 rsForm,
               )
                 ? appSignatureTypeList
                 : signatureTypeList;

                const filteredSignatureTypes = shouldHideESignature
                ? availableSignatureTypes.filter((type) => type.code !== 'esignature')
                : availableSignatureTypes;

               const availableValues = formatTypelistAvailableValues(
                 availableSignatureTypes,
               );

               const eSignatureValue = availableValues.find(
                 (item) => item.code === "esignature",
               );
               const shouldDefaultESignature = isEsignExt === true && !shouldHideESignature;
               if (shouldDefaultESignature && eSignatureValue) {
                 rsForm.signatureType.value = eSignatureValue;
               }
            const signatureType = _.get(rsForm, 'signatureType.value.code');

            const isSecondEmailRequired = (rsFrom) => {
                if (isEsignOptionSelected?.code === 'Text') {
                    const hasPhone = _.get(rsForm, "secondaryMobileNumber.value") != null && _.get(rsForm, "secondaryMobileNumber.value") !== "";
                    const hasValidPhone = hasPhone && _.get(rsForm, "secondaryMobileNumber.aspects.valid");
                    return shouldShowSecondEmail(rsForm) && !hasValidPhone;
                } else {
                    return shouldShowSecondEmail(rsForm);
                }
            };

            const isSecondPhoneRequired = (rsFrom) => {
                if (isEsignOptionSelected?.code === 'Text') {
                    const hasEmail = _.get(rsForm, "secondEmail.value") != null && _.get(rsForm, "secondEmail.value") !== "";
                    const hasValidEmail = hasEmail && _.get(rsForm, "secondEmail.aspects.valid");
                    return shouldShowSecondMobile(rsForm) && !hasValidEmail;
                } else {
                    return shouldShowSecondMobile(rsForm)
                }
            };

            return {
                [`formDescription${index}`]: {
                    content: rsForm.formDescription.value
                },
                [`formSignatureTypeDropdownSelect${index}`]: {
                    availableValues,
                    value: _.get(rsForm, 'signatureType.value'),
                    disabled: shouldDefaultESignature,
                    readOnly: shouldDefaultESignature                  },
                [`signatureFormLanguageRadio${index}`]: {
                    visible: shouldShowLanguageOption(),
                    value: _.get(rsForm, 'formLanguage.value.code')
                },
                [`mailingDescription${index}`]: {
                    visible: signatureType === 'usps'
                },
                [`downloadNextContainer${index}`]: {
                    visible: signatureType === 'agent_esignature' 
                    || signatureType === 'hard_copy'
                },
                [`faxContainer${index}`]: {
                    visible: signatureType === 'fax'
                },
                [`faxNumberInput${index}`]: {
                    messageProps: {
                        incompleteInput: rsForm.faxNumber.aspects.validationMessage
                    }
                },
                [`emailContainer${index}`]: {
                    visible: signatureType === 'email' || signatureType === 'esignature'
                },
                [`primaryInsuredEmailInput${index}`]: {
                    placeholder: translator(messages.enterEmail, { name: rsForm.namedInsuredName.value }),
                    className: shouldShowSecondEmail(rsForm) ? 'vertical-spacing-20' : 'undefined',
                    onBlur: (event) => handleOnBlur(rsForm.namedInsuredEmail, event),
                    onFocus: (event) => onTrimPrimaryEmail(rsForm, event),
                    visible: isEsignOptionSelected?.code !== 'Text' || _.isUndefined(isEsignOptionSelected?.code)
                },
                [`secondaryInsuredEmailInput${index}`]: {
                    visible: shouldShowSecondEmail(rsForm),
                    className: !checkIfEmailsAreDuplicated(rsForm) ? 'vertical-spacing-40' : 'undefined',
                    label: getSecondEmailLabel(rsForm),
                    onBlur: (event) => handleOnBlur(rsForm.secondEmail, event),
                    onFocus: (event) => onTrimSecondaryEmail(rsForm, event),
                    placeholder: translator(messages.enterEmail, { name: rsForm.secondName.value }),
                    required: isSecondEmailRequired(rsForm)
                },
                [`secondaryInsuredMobileInput${index}`]: {
                    visible: shouldShowSecondMobile(rsForm),
                    value: _.get(rsForm, "secondaryMobileNumber.value"),
                    className: !shouldShowSecondEmail(rsForm) ? 'vertical-spacing-40' : 'undefined',
                    label: getSecondMobileNumberLabel(rsForm),
                    placeholder: translator(messages.enterMobileNumber, { name: rsForm.secondName.value }),
                    required: isSecondPhoneRequired(rsForm)
                },
                [`emailOrMobileRequiredMessage${index}`]: {
                    visible: isEsignOptionSelected?.code === 'Text'
                        && showValidationErrors
                        && hasBothSecondaryEmailAndMobileEntered(rsForm)
                },
                [`duplicatedEmailDescription${index}`]: {
                    visible: checkIfEmailsAreDuplicated(rsForm)
                }
            }
        })
        return Object.assign({}, ...overrides);
    };

    const overrideProps  = {
        requiredSignaturesFormsIterable: {
            data: requiredSignaturesForms
        },
        ...generateRsFormsOverrides()
    };

    const onValueChange = (value, path) => {
        const [index, attribute] = path.split('.');

        switch(attribute) {
            case 'signatureType': {
                const rsForm = _.get(requiredSignaturesForms, index);
                signatureTypeChange(rsForm);
                clearActionFields(rsForm);
                break;
            }
            case 'faxNumber': {
                const unmaskedPhoneNumber = value.replace(/[^\d]/g, '');
                _.set(requiredSignaturesForms, path, unmaskedPhoneNumber);
                break;
            }
            case 'secondEmail': {
                const rsForm = _.get(requiredSignaturesForms, index);
                if (rsForm.secondaryInsuredEmailRequired.value) {
                    updateSecondaryInsuredEmail(value)
                }
                break;
            }
            default: {
                break;
            }
        }
    }

    const onModelChange = () => {
        refreshData();
    }

    const resolvers = {
        resolveClassNameMap: styles
    }
    
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            onValidationChange={onFormValidationChange}
            model={requiredSignaturesForms}
            onModelChange={onModelChange}
            onValueChange={onValueChange}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showValidationErrors}
        />
    );
};

RequiredSignaturesComponent.propTypes = {
    id: PropTypes.string.isRequired,
    requiredSignaturesForms: PropTypes.shape({}).isRequired,
    isSignatureOnFileAvailable: PropTypes.func.isRequired,
    appSignatureTypeList: PropTypes.shape({}).isRequired,
    signatureTypeList: PropTypes.shape({}).isRequired,
    shouldShowLanguageOption: PropTypes.func.isRequired,
    clearActionFields: PropTypes.func.isRequired,
    signatureTypeChange: PropTypes.func.isRequired,
    checkIfEmailsAreDuplicated: PropTypes.func.isRequired,
    shouldShowSecondEmail: PropTypes.func.isRequired,
    updateSecondaryInsuredEmail: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
};

export default RequiredSignaturesComponent;